import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { syncOffline } from "@/lib/offlineSync";

/** Tiene aggiornata la copia offline: al login, quando torna la rete e ogni 10 minuti. */
export default function OfflineSync() {
  const { user } = useAuth();
  const role = user?.role;
  const uid = user?.id;

  useEffect(() => {
    if (!role) return undefined;
    const run = () => { syncOffline(role); };
    const t = setTimeout(run, 2500);
    const interval = setInterval(run, 10 * 60 * 1000);
    window.addEventListener("online", run);
    return () => {
      clearTimeout(t);
      clearInterval(interval);
      window.removeEventListener("online", run);
    };
  }, [role, uid]);

  return null;
}
